import { render, staticRenderFns } from "./AccountsInput.vue?vue&type=template&id=0b89d7f3"
import script from "./AccountsInput.vue?vue&type=script&lang=js"
export * from "./AccountsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports